import { ROUTE_SESSION_EXPIRED } from '../routes/constants'

const KEY_AUTH_ACCESS_TOKEN = 'auth.access_token'
const KEY_AUTH_TOKEN_TYPE = 'auth.token_type'
const KEY_AUTH_EXPIRES_IN = 'auth.expires_in'
const KEY_AUTH_ISSUED = 'auth.issued'

export const clearSessionToken = () => {
  sessionStorage.removeItem(KEY_AUTH_ACCESS_TOKEN)
  sessionStorage.removeItem(KEY_AUTH_TOKEN_TYPE)
  sessionStorage.removeItem(KEY_AUTH_EXPIRES_IN)
  sessionStorage.removeItem(KEY_AUTH_ISSUED)
}

export const removeHash = (uri) => {
  const hashIndex = uri.indexOf('#')
  if (hashIndex !== -1) {
    return uri.substr(0, hashIndex)
  }
  return uri
}

const createRedirectURI = () => {
  const source = removeHash(window.location.href)
  if (source.includes(ROUTE_SESSION_EXPIRED)) {
    return source?.replace(ROUTE_SESSION_EXPIRED, '')
  }
  return source
}

export const authQueryParamsToString = new URLSearchParams({
  client_id: process.env.AUTH_CLIENT_ID,
  redirect_uri: createRedirectURI(),
  response_type: 'token',
}).toString()

export const redirectToAuthService = () => {
  clearSessionToken()
  window.location.href = `${process.env.AUTH_URL}${authQueryParamsToString}`
}

export const queryStringHasToken = (params) => params.has('#access_token')

export const isTokenExpired = () => {
  const sessionTokenExpiresIn = sessionStorage.getItem(KEY_AUTH_EXPIRES_IN)
  const sessionTokenIssued = sessionStorage.getItem(KEY_AUTH_ISSUED)

  if (sessionTokenExpiresIn && sessionTokenIssued) {
    return Date.parse(sessionTokenIssued) + (parseInt(sessionTokenExpiresIn, 10) * 1000 - 300 * 1000) < Date.now()
  }

  return false
}

export const sessionHasValidToken = () => {
  const sessionToken = sessionStorage.getItem(KEY_AUTH_ACCESS_TOKEN)
  const sessionTokenType = sessionStorage.getItem(KEY_AUTH_TOKEN_TYPE)
  return !!(sessionToken && sessionTokenType === 'bearer' && !isTokenExpired())
}

export const setSessionStorageAuth = (searchParams) => {
  sessionStorage.setItem(KEY_AUTH_ACCESS_TOKEN, searchParams.get('#access_token'))
  sessionStorage.setItem(KEY_AUTH_EXPIRES_IN, searchParams.get('expires_in'))
  sessionStorage.setItem(KEY_AUTH_TOKEN_TYPE, searchParams.get('token_type'))
  sessionStorage.setItem(KEY_AUTH_ISSUED, new Date())
}

export const getSessionAccessToken = () => sessionStorage.getItem(KEY_AUTH_ACCESS_TOKEN)

export const getSessionStorageAuth = () => ({
  token: getSessionAccessToken(),
  issued: sessionStorage.getItem(KEY_AUTH_ISSUED),
  expires: sessionStorage.getItem(KEY_AUTH_EXPIRES_IN),
  type: sessionStorage.getItem(KEY_AUTH_TOKEN_TYPE),
})

export const sessionStatus = () => {
  if (isTokenExpired()) {
    return 'expired'
  }
  if (sessionHasValidToken()) {
    return 'valid'
  }
  return 'invalid'
}
